export default "__VITE_ASSET__Bzg4dJHs__"